import React from "react";
import VoiceAssistant from "./components/VoiceAssistant";

function App() {
  return (
    <div className="App min-h-screen flex items-center justify-center">
      <VoiceAssistant />
    </div>
  );
}

export default App;
